import { render } from "./viewReport.vue?vue&type=template&id=528fc4a8&scoped=true"
import script from "./viewReport.vue?vue&type=script&lang=js"
export * from "./viewReport.vue?vue&type=script&lang=js"

import "./viewReport.vue?vue&type=style&index=0&id=528fc4a8&scoped=true&lang=css"
import "./viewReport.vue?vue&type=style&index=1&id=528fc4a8&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528fc4a8"]])

export default __exports__